import { createSlice } from '@reduxjs/toolkit'
import { defaultTo } from 'ramda'

const slice = createSlice({
  name: 'dataAnalyticsEventGpsValues',
  initialState: {},
  reducers: {
    setGpsValues: (state, { payload }) => {
      state[payload.eventId] = payload.data
    },
  },
})

export const { setGpsValues } = slice.actions

export default slice.reducer

export const selectGpsValues = (eventId) => (state) =>
  defaultTo({}, state.dataAnalyticsEventGpsValues?.[eventId])
